import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return (dispatch, getState) => {
		dispatch({
	        type: 'COMBUSTIVEL_ENTRADA_MODO_TELA',
	        payload: {
				modo: modo,
				registro: registro,
				id_responsavel: registro.id_responsavel || getState().auth.usuario.id
			}
		});
	}
}
export function initForm(registro = { datahora_entrada: DateFormat.getDataHoraAtual() }) {
    return (dispatch, getState) => {
		dispatch([
	        initialize('combustivelEntradaForm', {
				...registro,
				datahora_entrada: registro.datahora_entrada ? DateFormat.formatarDataHoraSqlParaTela(registro.datahora_entrada) : null,
				id_responsavel: registro.id_responsavel || getState().auth.usuario.id
			})
		]);
	}
}

export function setFiltro(filtro) {
    return {
        type: 'COMBUSTIVEL_ENTRADA_FILTRO',
        payload: filtro
    };
}

export function getLista(id_empresa) {

	return (dispatch, getState) => {
		axios.get(`${consts.API_URL}/combustivelEntrada?id_empresa=${id_empresa}
			&data_inicial=${DateFormat.formatarDataTelaParaParametro(getState().combustivelEntrada.filtro.dataInicial)}
			&data_final=${DateFormat.formatarDataTelaParaParametro(getState().combustivelEntrada.filtro.dataFinal)}
			&id_usuario=${getState().combustivelEntrada.filtro.id_usuario}`)
		.then(resp => {
            dispatch({
		        type: 'COMBUSTIVEL_ENTRADA_LISTADO',
		        payload: resp
			});
        }).catch(ex => {

		});
    };
}

export function getListaTanque(id_empresa) {
    const request = axios.get(`${consts.API_URL}/tanque/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'COMBUSTIVEL_ENTRADA_TANQUE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaFornecedor(id_empresa) {
    const request = axios.get(`${consts.API_URL}/fornecedor/listarselect?id_empresa=${id_empresa}&combustivel=true`);
    return {
        type: 'COMBUSTIVEL_ENTRADA_FORNECEDOR_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCombustivel(id_empresa) {
    const request = axios.get(`${consts.API_URL}/combustivel/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'COMBUSTIVEL_ENTRADA_COMBUSTIVEL_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUsuario(id_empresa) {
    const request = axios.get(`${consts.API_URL}/usuario/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'COMBUSTIVEL_ENTRADA_USUARIO_SELECT_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
        axios.post(`${consts.API_URL}/combustivelEntrada`, {
			...registro,
			id_empresa: getState().auth.usuario.id_empresa,
			datahora_entrada: registro.datahora_entrada ? DateFormat.formatarDataHoraTelaParaSql(registro.datahora_entrada) : null
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(getState().auth.usuario.id_empresa));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/combustivelEntrada?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_empresa));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
